import { fetchRateCompare, fetchUSNCompareDataNew } from "../../api/api";

export const txCompare = async (utilityId: number, contract_term: number) => {
  try {
    const response = await fetchRateCompare(utilityId, contract_term);
    return await response?.response?.total_average_price;
  } catch (error) {
    console.error("Error fetching TX Compare data:", error);
    return 0;
  }
};

export const usnCompare = async (ZipCode: number, utilityId: number) => {
  try {
    const response = await fetchUSNCompareDataNew(ZipCode, utilityId);
    return await response?.data
  } catch (error) {
    console.error("Error fetching USN Compare data:", error);
    return 0;
  }
};
